(() => {
  const radix = 10;
  document.addEventListener('DOMContentLoaded', () => {
    const audioPlayerList = {};
    const audioPlayers = document.querySelectorAll('.audio-player');
    audioPlayers.forEach((audioPlayer) => {
      const url = audioPlayer.dataset.url;


      function onlyPlayOneIn(currentID) {
        audioPlayers.forEach((audioPlayer) => {
          const id = audioPlayer.dataset.id;

          if (currentID !== id) {
            const playBtn = audioPlayer.querySelector('.controls .toggle-play');
            if (!audioPlayer.paused && playBtn) {
              playBtn.classList.remove('pause');
              playBtn.classList.add('play');
              audioPlayerList[id].pause();
            }
          }
        });

        return 1;
      }

// turn 128 seconds into 2:08
      function getTimeCodeFromNum(num) {
        let seconds = parseInt(num, radix);
        let minutes = parseInt(seconds / 60, radix);
        seconds -= minutes * 60;
        const hours = parseInt(minutes / 60, radix);
        minutes -= hours * 60;

        if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
        return `${String(hours).padStart(2, 0)}:${minutes}:${String(
          seconds % 60
        ).padStart(2, 0)}`;
      }

      if (url === '') {
        return;
      }

      const audio = new Audio(url);
      const id = audioPlayer.dataset.id;
      audio.preload = 'none';
      audioPlayerList[id] = audio;
      audio.addEventListener(
        'loadeddata',
        () => {
          audioPlayer.querySelector('.time .length').textContent = getTimeCodeFromNum(
            audio.duration
          );
          audio.volume = 0.75;
        },
        false
      );

// click on timeline to skip around
      const timeline = audioPlayer.querySelector('.timeline');
      timeline.addEventListener('click', (e) => {
        const timelineWidth = window.getComputedStyle(timeline).width;
        const timeToSeek = ((e.offsetX / parseInt(timelineWidth, radix)) * audio.duration);
        audio.currentTime = timeToSeek;
      }, false);

// click volume slider to change volume
      const volumeSlider = audioPlayer.querySelector('.controls .volume-slider');
      volumeSlider.addEventListener('click', (e) => {
        const sliderWidth = window.getComputedStyle(volumeSlider).width;
        const newVolume = e.offsetX / parseInt(sliderWidth, radix);
        audio.volume = newVolume;
        audioPlayer.querySelector('.controls .volume-percentage').style.width = `${(newVolume * 100)}%`;
      }, false);

// check audio percentage and update time accordingly
      setInterval(() => {
        const progressBar = audioPlayer.querySelector('.progress');
        progressBar.style.width = `${(audio.currentTime / audio.duration) * 100}%`;
        audioPlayer.querySelector('.time .current').textContent = getTimeCodeFromNum(
          audio.currentTime
        );
      }, 500);

// toggle between playing and pausing on button click
      const playBtn = audioPlayer.querySelector('.controls .toggle-play');
      playBtn.addEventListener(
        'click',
        () => {
          if (onlyPlayOneIn(audioPlayer.dataset.id)) {
            if (audio.paused) {
              playBtn.classList.remove('play');
              playBtn.classList.add('pause');
              audio.play();
            } else {
              playBtn.classList.remove('pause');
              playBtn.classList.add('play');
              audio.pause();
            }
          }
        },
        false
      );

      audioPlayer.querySelector('.volume-button').addEventListener('click', () => {
        const volumeEl = audioPlayer.querySelector('.volume-container .volume');
        audio.muted = !audio.muted;
        if (audio.muted) {
          volumeEl.classList.remove('icono-volumeMedium');
          volumeEl.classList.add('icono-volumeMute');
        } else {
          volumeEl.classList.add('icono-volumeMedium');
          volumeEl.classList.remove('icono-volumeMute');
        }
      });
    });

// link click
    const teaserLink = document.getElementsByClassName('park-teaser__link');
    for (let i = 0; i < teaserLink.length; i += 1) {
      teaserLink[i].addEventListener('click', (event) => {
        if (event.target.closest('.park-teaser__audio')) {
          event.preventDefault();
        }
      });
    }
  });
})();
